<template>
    <v-layout row>
        <v-flex xs12 v-if="loyaltyMovements.length > 0">
            <router-view/>
            <v-list
                    v-for="movement in loyaltyMovements"
                    :key="movement.id"
                    two-line>
                <v-list-tile>
                    <v-list-tile-content class="mr-2 ml-2">
                        <v-list-tile-title>{{movement.loyalty_campaign}}</v-list-tile-title>
                        <v-list-tile-sub-title>{{movement.date}}</v-list-tile-sub-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                        <v-list-tile-title class="secondary--text text-xs-center headline font-weight-bold">
                            {{movement.points}}
                        </v-list-tile-title>
                        <v-list-tile-sub-title class="secondary--text text-xs-center text-lowercase"> {{
                            $vuetify.t('$vuetify.points') }}
                        </v-list-tile-sub-title>
                    </v-list-tile-action>
                </v-list-tile>

            </v-list>
            <mugen-scroll :handler="getNextLoyaltyMovements" :should-handle="!loading && hasMoreResults">
                <!-- Verifying the flag which defines whether or not there are more results to load -->
                <p v-if="loading">...</p>
            </mugen-scroll>
            </v-flex>
            <v-flex xs12 v-else>
            <v-layout align-center justify-center column>
                <v-spacer class="my-4"></v-spacer>
                <v-icon style="font-size: 150px">fal fa-shopping-cart</v-icon>
                <v-spacer class="my-4"></v-spacer>
                <h2 class="title text-xs-center">{{ $vuetify.t('$vuetify.no_movements_to_display') }}</h2>
            </v-layout>

        </v-flex>
    </v-layout>
</template>

<script>
    import {loyaltyMovementsService} from '../../_services'
    import {getErrorMessage, getUrlParams} from '../../_helpers'
    import MugenScroll from 'vue-mugen-scroll'

    export default {
        name: "LoyaltyMovements",
        components: {MugenScroll},
        data() {
            return {
                loading: false,
                hasMoreResults: true,
                nextPageUrl: null,
                loyaltyMovements: [],
            }
        },
        methods: {
            //This function is triggered by the infinite slider. By default, only 15 loyalty movements are displayed,
            // when the user has more than 15 loyalty movements and scrolls on the interface,
            // this GET is triggered to obtain the following 15 loyalty movements and append them to the Loyalty Movements' Array
            getNextLoyaltyMovements() {
                //Setting the loading flag to true
                this.loading = true;
                //Verifying there are more Loyalty Movements to fetch
                if (this.nextPageUrl !== null) {
                    this.$store.dispatch("loader/setLoading", true);

                    loyaltyMovementsService.getAll(getUrlParams(this.nextPageUrl)).then(result => {
                            //Adding the fetched Loyalty Movements to the existing list of Loyalty Movements
                            this.loyaltyMovements = this.loyaltyMovements.concat(result.results);
                            this.loading = false;
                            //Updating the URL which retrieves the following 15 Loyalty Movements
                            // (it has a page=X which helps on this process)
                            // When there are no more Loyalty Movements to fetch, the URL is set to NULL and the flag which
                            // states whether or not the word "loading" should be displayed is set to false
                            this.nextPageUrl = result.next;
                            this.hasMoreResults = this.nextPageUrl !== undefined;
                            this.$store.dispatch("loader/setLoading", false);
                        },
                        error => {
                            getErrorMessage(error, 'Getting the Loyalty Movements', this);
                        }
                    );
                } else
                    this.loading = false
            }
        },
        mounted() {
            loyaltyMovementsService.getAll().then(result => {
                    this.nextPageUrl = result.next;
                    this.hasMoreResults = this.nextPageUrl !== undefined;
                    this.loyaltyMovements = result.results;
                },
                // eslint-disable-next-line
                error => {
                    this.$store.dispatch("loader/setLoading", false);
                    this.$store.dispatch("alert/error", this.$vuetify.t('$vuetify.generic_error'));
                }
            );
        },
    }
</script>

<style scoped>

</style>